import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import Autosuggest from 'react-autosuggest'
import * as services from '../../../services'
import { change } from 'redux-form'

export class EaseOnAutoSuggest extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
      results: [],
    }
    this.endpoint = props.endpoint
    this.getSuggestionValue = this.getSuggestionValue.bind(this)
    this.renderSuggestion = this.renderSuggestion.bind(this)
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSuggestionsFetchRequested =
      this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionsClearRequested =
      this.onSuggestionsClearRequested.bind(this)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({ value: nextProps.value })
    }
  }
  getSuggestionValue(selectedSuggestion) {
    const { dispatch, form } = this.props.meta
    const { actualFieldName } = this.props
    dispatch(change(form, actualFieldName, selectedSuggestion.url))
    if (this.endpoint === 'organizations') {
      return selectedSuggestion.code + ' - ' + selectedSuggestion.name
    }
    return selectedSuggestion.first_name + selectedSuggestion.last_name
  }
  renderSuggestion(suggestion, { query }) {
    return this.props.renderSuggestion(suggestion)
  }
  onSuggestionSelected(event, { suggestionValue, method }) {
    const { input } = this.props
    input.onChange(suggestionValue)
    if (method === 'enter') {
      event.preventDefault()
    }
  }
  onChange(event, { newValue, method }) {
    this.setState({
      value: newValue,
    })
  }
  onSuggestionsFetchRequested({ value }) {
    const search_object = {}
    search_object[this.props.searchKey] = value
    const url = this.endpoint
    new services.RestService(url).makeSearchRequest(value).then((response) => {
      this.setState({
        results: response.results,
      })
    })
  }
  onSuggestionsClearRequested() {
    this.setState({
      results: [],
    })
  }
  render() {
    const { value, results } = this.state
    const { initialValue } = this.props

    const tempProps = {
      placeholder: this.props.placeholder,
      className: 'form-control',
      value,
      onChange: this.onChange,
    }
    return (
      <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
        <ReactBootstrap.Form.Label>
          {this.props.label}
        </ReactBootstrap.Form.Label>
        <Autosuggest
          suggestions={results}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          onSuggestionSelected={this.onSuggestionSelected}
          inputProps={tempProps}
        />
        {initialValue ? (
          <p className="text-end">
            Current {this.props.label}:{' '}
            <ReactBootstrap.Form.Label>
              {initialValue}
            </ReactBootstrap.Form.Label>
          </p>
        ) : (
          ''
        )}
      </ReactBootstrap.Form.Group>
    )
  }
}
